import BaseAPI from './base.api';
import { TEmailProviderTemplatePayload, TEmailTemplate } from 'components/FlowBuilder/FlowSidePanels/types';

class EmailAPI extends BaseAPI {
  private ROUTES = {
    emailTemplates: 'integrations/webhook/email/sendgrid/templates',
  };

  private queryParams = {
    limit: 0,
    offset: 0,
  };

  getEmailTemplates(params = {}): Promise<TEmailTemplate[]> {
    const queryParams = { ...this.queryParams, ...params };
    return this.GET(this.ROUTES.emailTemplates, queryParams);
  }

  getEmailTemplate(templateId: string): Promise<TEmailProviderTemplatePayload> {
    return this.GET(this.buildURL(`${this.ROUTES.emailTemplates}/:templateId`, { templateId }));
  }
}

const emailService = new EmailAPI();

export default emailService;
